const useFixScroll = () => {
  const fixScrollInAndroidChrome = () => {
    const fixScroll = () => {
      const isDesktop = window.innerWidth >= 1366

      if (isDesktop) {
        return
      }

      const { activeElement } = document

      if (!activeElement) {
        return
      }

      if (activeElement.tagName !== 'INPUT') {
        return
      }

      if (activeElement.classList.contains('tabs-switch__control')) {
        return
      }
      const timeouts = [50, 100, 150, 300, 500, 1000, 2000]

      timeouts.forEach(timeout => {
        setTimeout(() => {
          const element: any | never = activeElement

          element?.scrollIntoViewIfNeeded(true)
        }, timeout)
      })
    }

    document.addEventListener('click', fixScroll, true)

    return () => {
      document.removeEventListener('click', fixScroll, true)
    }
  }

  return {
    fixScrollInAndroidChrome
  }
}

export default useFixScroll
